export default __webpack_public_path__ + "static/media/slot21.57579108.png";